export default __webpack_public_path__ + "217d272ced86b6187110ecf72ad55f4d.svg";